import { render, staticRenderFns } from "./PaymentReports.vue?vue&type=template&id=11c8e9a2&scoped=true&"
import script from "./PaymentReports.vue?vue&type=script&lang=js&"
export * from "./PaymentReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8e9a2",
  null
  
)

export default component.exports